import {useEffect, useRef} from 'react';

// NOTE: this is duplicated from src/v2/util/useSingleRunEffect.ts. Consider moving to shared util.
/**
 * A custom hook that is equivalent to useEffect(callback, []) but respects the ESLint rule.
 * Runs an effect only once when the condition callback returns true, regardless of dependency changes.
 */
export const useSingleRunEffect = (
  effect: () => void | (() => void),
  condition: () => boolean = () => true,
) => {
  const hasRun = useRef(false);
  const shouldRun = condition();
  useEffect(() => {
    if (shouldRun && !hasRun.current) {
      const cleanup = effect();
      hasRun.current = true;

      return cleanup;
    }
  }, [effect, shouldRun]);
};
